import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selecFullAccount } from '../data/user';

const RestrictedRoute = ({ children, ...rest }) => {
  const isTeamAccount = useSelector(selecFullAccount);

  return (
    <Route
      {...rest}
      render={() =>
        isTeamAccount ? <Redirect to="/accountnew/landing" /> : children
      }
    />
  );
};

export default RestrictedRoute;